/**
 * Lead sources in the CRM's convention: the platform and whether it was paid. Other referring sites appear as their
 * hostname, and leads with no clue as "Unknown". Offered as suggestions; any value is accepted.
 */
export const SOURCE_OPTIONS = [
  'Google (paid)', 'Google (organic)',
  'Facebook (paid)', 'Facebook (organic)',
  'Instagram (paid)', 'Instagram (organic)',
  'Messenger (paid)', 'Audience Network (paid)',
  'TikTok (paid)', 'TikTok (organic)',
  'AI (paid)', 'AI (organic)',
  'Website (Direct)', 'Unknown',
];

/** "Google (paid)" → paid; "(organic)", "Website (Direct)", hostnames and "Unknown" are not paid. */
export function isPaidSource(source: string | null): boolean {
  return /\(paid\)\s*$/i.test(source ?? '');
}
